export const USER_DATA = "USER_DATA";
export const USER_ME = "USER_ME";
export const CART_PUB = "CART_PUB";
export const CART_PUB_SHORT = "CART_PUB_SHORT";
export const CART = "CART";
export const CART_SHORT = "CART_SHORT";
export const CART_MANAGER = "CART_MANAGER";
export const CATALOG = "CATALOG";
export const RECOMMEND_CARDS = "RECOMMEND_CARDS";
export const BLOGGER_CHANNELS = "BLOGGER_CHANNELS";
export const BLOGGER_OFFERS = "BLOGGER_OFFERS";
export const ADV_PROJECTS = "ADV_PROJECTS";
export const ADV_ORDERS = "ADV_ORDERS";
export const ADV_TARIFF_PROJECTS = "ADV_TARIFF_PROJECTS";
export const ADV_TARIFF_ORDERS = "ADV_TARIFF_ORDERS";
export const MANAGER_PROJECTS = "MANAGER_PROJECTS";
export const MANAGER_ORDERS = "MANAGER_ORDERS";
export const BALANCE = "BALANCE";
export const TRANSACTION_HISTORY = "TRANSACTION_HISTORY";
export const LEGALS = "LEGALS";
export const CHAT = "CHAT";
export const ADMIN_REVIEWS = "ADMIN_REVIEWS";
export const ADMIN_COMPLAINTS = "ADMIN_COMPLAINTS";
export const ADMIN_ACCOUNTING = "ADMIN_ACCOUNTING";
export const ADMIN_CHANNELS = "ADMIN_CHANNELS";
export const VIEWS_BLOGGER_CHANNELS = "VIEWS_BLOGGER_CHANNELS";
export const VIEWS_BLOGGER_OFFERS = "VIEWS_BLOGGER_OFFERS";
export const VIEWS_ADVERTISER = "VIEWS_ADVERTISER";
export const VIEWS_MANAGER = "VIEWS_MANAGER";
export const VIEWS_TRANSACTIONS = "VIEWS_TRANSACTIONS";
export const CREATE_PROJECT_NAME = "CREATE_PROJECT_NAME";
export const CREATE_PROJECT_POSTS = "CREATE_PROJECT_POSTS";
export const CREATE_PROJECT_DATES = "CREATE_PROJECT_DATES";
export const CREATE_PROJECT_AMOUNT = "CREATE_PROJECT_AMOUNT";
export const MY_ORGANIZATION = "MY_ORGANIZATION";
export const POST_TEMPLATES = "POST_TEMPLATES";
export const POST_ORDER = "POST_ORDER";
export const AGENCY_PROJECTS_CUSTOMER = "AGENCY_PROJECTS_CUSTOMER";
export const AGENCY_PROJECTS_MANAGER = "AGENCY_PROJECTS_MANAGER";
export const AGENCY_PROJECTS_PUBLISHER = "AGENCY_PROJECTS_PUBLISHER";
